// extracted by mini-css-extract-plugin
export default {"alignCenter":"Game_alignCenter__bvbqc"};